/**
 * Konfigurácia ATT ⇄ Cookiebot adaptéra — mapovanie iOS ATT odpovede na
 * Cookiebot kategórie.
 *
 * ATT je jedno áno/nie, Cookiebot má tri opt-in kategórie — a keďže je banner
 * v appke skrytý, kategória, ktorú ATT neriadi, sa nedá udeliť inak. Preto:
 * sledovanie (`statistics`, `marketing`) ide podľa ATT, funkčné cookies
 * (`preferences`) sú v appke vždy udelené, takže odmietnutie sledovania nezhodí
 * komfortné funkcie webu. Je to právne rozhodnutie pre Lunys — platformový
 * default je „ATT riadi všetky tri kategórie".
 *
 * Vlastný modul, nie riadok v index.js: ESM importy sa hoistujú, takže
 * priradenie zapísané medzi importami by prebehlo AŽ PO evale adaptéra.
 */
window.__appAttCookiebotConfig = {
    // Shop bez CMP: nie je do čoho zapísať súhlas — v appke sa netrackuje a ATT
    // sa nežiada. Server to signalizuje v base.ctp podľa `Custom.cookiebotId`.
    // Od 2026-09-29 ho majú oba shopy (B2B len pre appku, vkladá ho server —
    // docs/plans/b2b-app-cookiebot.md); vetva ostáva ako poistka pre shop bez
    // `cookiebotId`.
    disabled: window.__appNoCmp === true,
    categories: ["statistics", "marketing"],
    alwaysGranted: ["preferences"],
    // Tracking je gatovaný aj server-side (AppTracking + EcommerceTrackingHelper),
    // takže HTML vzniká s consent stavom z cookie na začiatku page loadu — po
    // zmene súhlasu musí prísť prekreslenie, inak by trackery nabehli až pri
    // najbližšej navigácii. Platí pre ATT zápis (iOS) aj odpoveď v banneri (Android).
    reload: true,
};
